// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__ZMJcd","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2N9qs"};